import { DetailPageActionTypes } from '../actions/constants'
import { Reducer } from 'redux'
import { DetailPageActions } from '../actions'
import { TriggerPurchasingTransition, RemoveActionBoxTransitionPayload } from '../actions/actionBox';

export enum ActionBoxState {
  purchasing = 'purchasing',
  failed = 'failed',
}

export const initialState = {}

export type ActionBoxTitleStatus = {
  state: ActionBoxState
  offerAsin: string
  canonicalTitleId?: string
  isSeasonPurchase: boolean
  purchasingText: string
  errorHeader: string
}

export type ActionBoxStatus = {
  [canonicalTitleIdOrMain: string]: ActionBoxTitleStatus
}

const triggerPurchasingTransition = (state: ActionBoxStatus, { offerAsin, isSeasonPurchase, canonicalTitleId, purchasingText, errorHeader }: TriggerPurchasingTransition) => ({
  ...state,
  main: {
    state: ActionBoxState.purchasing,
    isSeasonPurchase,
    offerAsin,
    purchasingText,
    errorHeader,
  },
  ...(canonicalTitleId ? { [canonicalTitleId]: { state: ActionBoxState.purchasing, offerAsin, purchasingText, errorHeader } } : {})
})

const removePurchasingTransition = (state: ActionBoxStatus, { offerAsin, canonicalTitleId }: RemoveActionBoxTransitionPayload) => {
  const newState = { ...state }

  if (newState.main && newState.main.offerAsin === offerAsin) {
    delete newState.main
  }

  if (canonicalTitleId && newState[canonicalTitleId]) {
    delete newState[canonicalTitleId]
  }

  return newState
}

const updatePurchasingStatus = (state: ActionBoxStatus, purchasingState: ActionBoxState, { offerAsin, canonicalTitleId }: RemoveActionBoxTransitionPayload) => {
  const newState = { ...state }

  if (state.main && state.main.offerAsin === offerAsin) {
    newState.main = {
      ...state.main,
      state: purchasingState
    }
  }

  if (canonicalTitleId && state[canonicalTitleId]) {
    newState[canonicalTitleId] = {
      ...state[canonicalTitleId],
      state: purchasingState
    }
  }

  return newState
}

export const reducer: Reducer<ActionBoxStatus, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.TriggerPurchasingTransition:
      return triggerPurchasingTransition(state, action.payload)
    case DetailPageActionTypes.RefreshAtfActionBox:
      return removePurchasingTransition(state, action.payload)
    case DetailPageActionTypes.ResetPurchasingTransition:
      return removePurchasingTransition(state, action.payload)
    case DetailPageActionTypes.FailedPurchasingDueToClientDependency:
      return updatePurchasingStatus(state, ActionBoxState.failed, action.payload)
    default:
      return state
  }
}
